export default "__VITE_ASSET__Bd4o4CJg__"